import { usePermissions } from '../store/Permissions'
import MenuApi from '../view/menu/api/index'
import { handleTree } from '../utils/dict';
import { dayjs } from 'element-plus';
import TimeService from '../remoteservice/TimeService';
//录制接口权限
const addRole = false
//录制按钮权限
const addMenu= false
export const getBoolean = (value, data, defaultValue) => {
    if (defaultValue == null) defaultValue = false;
    if (value == null) return defaultValue;
    if (!data) data = {};
    if (value instanceof Function) return value(data);
    if (typeof value == 'string') {
        value = value.replace(/\{(\w+)\}/g, ($0, $1)=> {
            if ($1 == 'now') return '\'' + TimeService.getServerTimeStr() + '\'';
            return '';
        })
        return eval(value);
    }
    return !!value;
}

export const getString = (value, data, defaultValue) => {
    if (defaultValue == null) defaultValue = '';
    if (value == null) return defaultValue;
    if (!data) data = {};
    if (value instanceof Function) return value(data);
    return value + '';
}

export const getPermissions = (code, route, module, url) => {
    let obj = {
        'DELETE': 'remove',
        'DELETE_BATCH': 'remove',
        'VIEW': 'list',
        'VIEWENTITY': 'list',
        'EDIT': 'edit',
        'ADD': 'add',
        'SAVE': 'add',
        'ADDWITHPARENT': '',
        'LOCK': 'lock',
        'ACTIVATE': 'edit',
        'UNLOCK': 'unlock',
        "STATISTICS": 'summary',
        'table-row/DELETE': 'remove',
        'table-row/DELETE_BATCH': 'remove',
        'table-row/VIEW': 'list',
        'table-row/VIEWENTITY': 'list',
        'table-row/EDIT': 'edit',
        'table-row/ADD': 'add',
        'table-row/ADDWITHPARENT': '',
        'table-row/LOCK': 'lock',
        'table-row/UNLOCK': 'unlock',
        'DEACTIVATE': 'edit',
        'FINANCENP': 'gartheringAndAdvance',
        'FINANCENPS': 'gartheringAndAdvance',
        'FINANCECASH': {
            module: 'fmpCashFlow',
            code: "gartheringAndAdvance"
        },
        'FINANCECASHS': {
            module: 'fmpCashFlow',
            code: "gartheringAndAdvance"
        },
        'FINANCENPIMP': 'finsConfirm',
        'FINANCENPIMPS': 'finsConfirm',
        'FINANCENPRECORD': 'financeConfirm',
        'FINANCENPRECORDS': 'financeConfirm',
        'FINANCECONFIRM': 'financeConfirm',

    }
    // 'CONTRAST': '',
    if (code === undefined) return true
    const Permissions = usePermissions();
    let uniquecode = (route + '/' + code).replace(/[/]$/, "")
    // console.log(uniquecode, module, url)
    if (addRole && module && Permissions.menuItem[uniquecode]?.perms == '') {
        // console.log(uniquecode, module)
        // let per = getPermissioss(Permissions.roleItem, '')
        let param = JSON.parse(JSON.stringify(Permissions.menuItem[uniquecode]))
        if (url) {
            let urlcode = url.split('/')
            if (urlcode[urlcode.length - 1] == '{id}') {
                param.perms = 'hepfmp:' + urlcode[urlcode.length - 3] + ':' + urlcode[urlcode.length - 2]
                console.log(urlcode[urlcode.length - 2], urlcode[urlcode.length - 3], '有id')
            } else {
                param.perms = 'hepfmp:' + urlcode[urlcode.length - 2] + ':' + urlcode[urlcode.length - 1]
            }
            MenuApi.updateMenu(param).then(response => {
                // getList();
            });
            console.log(Permissions.menuItem[uniquecode], module, url, urlcode)

        }
        if (obj[Permissions.menuItem[uniquecode].component]) {
            if (obj[Permissions.menuItem[uniquecode].component].module) {
                param.perms = 'hepfmp:' + obj[Permissions.menuItem[uniquecode].component].module + ':' + obj[Permissions.menuItem[uniquecode].component].code
            } else {
                param.perms = 'hepfmp:' + module + ':' + obj[Permissions.menuItem[uniquecode].component]
            }
            MenuApi.updateMenu(param).then(response => {
                // getList();
            });
            console.log(Permissions.menuItem[uniquecode], module)
        }

    }
    // console.log( Permissions._map[uniquecode],code,uniquecode)
    return Permissions._map[uniquecode] ? true : false
}
export function getPermissioss(data, code) {
    var permissios = {};
    var datas = JSON.parse(JSON.stringify(data));
    var treedata = handleTree(datas, 'menuId')
    // console.log(treedata)
    datas.forEach(it => {
        let str = ''
        let ids = JSON.parse(JSON.stringify(getParent(datas, treedata, it.menuId)))
        // console.log(ids)
        ids.forEach((its, index) => {
            let code = ids.length == 1 || index == ids.length - 1 ? '' : '/'
            str += `${its.component + code}`
        })
        str.replace(/\s+/g, "");
        permissios[str] = it
        // console.log(str,ids)
    })
    return permissios
}
function getParent(datas, list, id) {
    if (!list || !id) {
        return ''
    }
    let arr = [];
    let findParent = (datas, data, nodeId, parentId) => {
        for (var i = 0, length = data.length; i < length; i++) {
            let node = data[i];
            if (node.menuId == nodeId) {
                let n = datas.filter(it => it.menuId == nodeId)
                arr.unshift(n[0]);
                if (nodeId == list[0].menuId) {
                    break
                }
                findParent(datas, list, parentId);
                break
            } else {
                if (node.children) {
                    findParent(datas, node.children, nodeId, node.menuId);
                }
                continue
            }
        }
        return arr;
    }
    return findParent(datas, list, id);
}